export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'RULES': 'Game rules',
    "WORTH": "Worth 2,500 EUR",
    "WIN": "Win",
    "JUSTFIT": "Justfit",
    "ME": "Me",
    "HERO_DESC": "Win the first EMS system you can use anytime, anywhere!",
    "SEARCH_JUSTFIT": 'Justfit stand: Hall IV. stand 4.20',
    "ATTENDANCE": "Terms of participation:",
    "LIST_1": "Visit Justfit stand at FIWE in Hall IV. stand 4.20",
    "LIST_2": "Take a selfie in front of <span class='c-justfit-yellow font-weight-semibold'>#winjustfitme</span> photo wall",
    "LIST_3": "    3. Upload your photo to Instagram or Facebook with the hashtag <span class='c-justfit-yellow font-weight-semibold'>#winjustfitme</span> Deadline: 15. 09. 2019 midnight",
    "SUIT_HEADING": "1 JustfitMe EMS system worth 2,500 EUR",
    "PRIZE": "FIRST PRIZE:",
    "LIST2_1": "Unisex JustfitMe hybrid technology suit - choose the style you like most",
    "LIST2_2": "JustfitMe control unit",
    "LIST2_3": "JustfitMe mobile app",
    "SECOND_TEXT": "Win the first EMS (electro-muscle stimulation) system that can be used anywhere, anytime without limits. Due the efficient EMS technology, you can keep fit with only 2 x 20 minutes training per week.  Not to mention that it looks very, very cool.",
    "SECOND_TEXT_2": "Other prizes: 3 Justfit T-shirts.",
    "SECOND_TEXT_3": "Winners will be announced on our <span class='c-justfit-yellow font-weight-semibold'>Instagram</span> and <span class='c-justfit-yellow font-weight-semibold'>Facebook</span> page and in private messages until 22.09.2019. Think of tomorrow, play now!",
    "AMAZING_HASHTAG": "#winjustfitme",
}
